import { CardContainer } from './components/CardContainer';
import { ContentWrapper } from './EventSites.styles';
import { EmbedInfo } from './components/EmbedInfo';
import { EventSiteDefaultStyles } from './components/EventSiteDefaultStyles';
import { FILTER_OPTIONS } from 'features/common/components/Filters/LocalFilter/constants';
import { FilterOptionType } from 'features/common/components/Filters/LocalFilter/types';
import { FlexContainer } from 'features/common/components/FlexContainer';
import { LocalFilter } from 'features/common/components/Filters/LocalFilter';
import { Search } from 'features/common/components/Search';
import { Title } from 'features/Embed/Embed.styles';
import { useDebounce } from 'utils/utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const EventSites = (): JSX.Element => {
	const { t } = useTranslation();
	const [searchQuery, setSearch] = useState('');
	const [selectedOption, setSelectedOption] = useState<FilterOptionType>(FILTER_OPTIONS[2]);

	const onChangeSearch = useDebounce(setSearch);

	const onChangeFilter = (option: FilterOptionType) => {
		setSelectedOption(option);
	};

	return (
		<ContentWrapper>
			<EmbedInfo />
			<EventSiteDefaultStyles />
			<Title>{t('embedInfo-events')}</Title>
			<FlexContainer justifyContent="space-between" width="100%">
				<Search placeholder="Search" onChange={(e) => onChangeSearch(e.target.value)} data-cy="search-input" />
				<LocalFilter onChange={onChangeFilter} options={FILTER_OPTIONS} selectedOption={selectedOption} />
			</FlexContainer>
			<CardContainer searchQuery={searchQuery} selectedOption={selectedOption} />
		</ContentWrapper>
	);
};

export default EventSites;
